import { NgModule } from '@angular/core';
import { NgOtpInputComponent } from './components/ng-otp-input/ng-otp-input.component';

@NgModule({
  imports: [
    NgOtpInputComponent
  ],
  exports: [NgOtpInputComponent]
})
export class NgOtpInputModule { }
